/**
 * BreakScreen Component
 * Displays the break screen between PMP exam blocks
 */
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Coffee, Play } from 'lucide-react';
import { formatTime } from './examConfig';

const BreakScreen = ({
  breakTimeRemaining,
  currentBlock,
  totalBlocks,
  onContinue
}) => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-[#0047AB]/10 dark:bg-[#0047AB]/20 flex items-center justify-center mx-auto mb-6">
            <Coffee className="w-10 h-10 text-[#0047AB]" />
          </div>
          
          <h2 className="text-2xl font-bold mb-2">Break Time</h2>
          <p className="text-slate-600 dark:text-slate-400 mb-6">
            You've completed Block {currentBlock} of {totalBlocks}. 
            Take a short break before continuing.
          </p>
          
          <div className="text-5xl font-mono font-bold text-[#0047AB] mb-6">
            {formatTime(breakTimeRemaining)}
          </div>
          
          <p className="text-sm text-slate-500 mb-6">
            The exam will automatically continue when the break ends.
          </p>
          
          <Button 
            className="w-full bg-[#0047AB] hover:bg-[#003380]"
            onClick={onContinue}
            data-testid="continue-exam-btn"
          >
            <Play className="w-4 h-4 mr-2" />
            Continue Now
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default BreakScreen;
